import React from 'react';
import { parseCommentText } from './commentUtils';

/**
 * Read-only render of a comment body. Resolves `@[staffId]` tokens to mention
 * chips using the comment's populated `mentions`, and preserves line breaks.
 */
export const CommentText = ({ text, mentions }) => {
    const segments = parseCommentText(text, mentions);
    return (
        <p className="comment-text">
            {segments.map((seg, i) =>
                seg.type === 'mention' ? (
                    <span key={i} className="comment-text-mention">
                        {seg.value}
                    </span>
                ) : (
                    <span key={i}>{seg.value}</span>
                ),
            )}
        </p>
    );
};
